import _get from 'lodash/get';
import _set from 'lodash/set';

/**
 * Returns only data from the application metaData based on a list of given keys.
 * If no keys are provided, the whole metadata object is returned
 *
 * @param application - The application to get metaData from
 * @param paths - A list of paths that should be written from the application to the return obj
 */
export default function (application = {}, paths = []) {
  let returnApplication = {};
  if (!paths || !paths.length || !application) {
    return returnApplication;
  }
  paths.forEach((path) =>
    _set(returnApplication, path, _get(application, path))
  );
  return returnApplication;
}
